export const mailtoLink = (email: string, subject?: string) =>
    `mailto:${email}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`
